import { render, staticRenderFns } from "./FeaturedItemsComponent.vue?vue&type=template&id=36e9f3ea"
import script from "./FeaturedItemsComponent.vue?vue&type=script&lang=js"
export * from "./FeaturedItemsComponent.vue?vue&type=script&lang=js"
import style0 from "./FeaturedItemsComponent.vue?vue&type=style&index=0&id=36e9f3ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports